import { createSelector } from '@reduxjs/toolkit';
import { DateTime } from 'luxon';

import { MetricsFilterParams } from 'dashboard/redux/actions/metrics-transaction';
import { RootState } from 'dashboard/redux/store';

const getTransactionFilters = (state: RootState) => state.metricsTransaction.filters;

export const getAdjustedFilters = createSelector(
  [getTransactionFilters],
  (filters: MetricsFilterParams) => {
    if (filters.createdAtStart != null && filters.createdAtEnd != null) {
      return filters;
    }

    const now = DateTime.local();
    const startOfDay = now.startOf('day');
    const endOfDay = startOfDay.endOf('day');
    const startTimeRange = startOfDay.minus({ days: 14 });
    return {
      ...filters,
      createdAtStart: startTimeRange.toUTC().toISO(),
      createdAtEnd: endOfDay.toUTC().toISO(),
    };
  },
);
